import { render, staticRenderFns } from "./EntityTable.vue?vue&type=template&id=131cb477&"
import script from "./EntityTable.vue?vue&type=script&lang=js&"
export * from "./EntityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports